export default __webpack_public_path__ + "305ab250c91b60ebf160fcf930fd18a1.svg";